export function fixedElement() {
    const fixedTarget = document.querySelector("[data-fixed]");
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0,
    };

    const observerCallback = (entries, observer) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                fixedTarget.classList.remove("-append");
            } else {
                fixedTarget.classList.add("-append");
            }
        }
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const targetElements = document.querySelectorAll("[data-observed]");
    for (const element of targetElements) {
        observer.observe(element);
    }
}
